import {makeAutoObservable} from "mobx";
import {ApiUsersService} from "../../../shared/api";

// "Пользователи": one page of the list with its search and filters (the server searches and counts)
class UsersModel {
  users = []
  errors = {}
  total = 0
  blocked = 0
  page = 1
  limit = 50
  search = ''
  role = undefined
  status = undefined
  sort = 'createdAt'
  isLoading = false
  requestId = 0

  constructor() {
    makeAutoObservable(this)
  }

  setUsers(users) {
    this.users = users
  }

  setErrors(errors) {
    this.errors = errors
  }

  setList({items, total, blocked, page}) {
    this.users = items
    this.total = total
    this.blocked = blocked
    this.page = page
  }

  setLoading(isLoading) {
    this.isLoading = isLoading
  }

  setFilters(filters) {
    Object.assign(this, filters, {page: 1})
    this.fetch()
  }

  setPage(page, limit) {
    this.page = page
    if (limit) this.limit = limit
    this.fetch()
  }

  async fetch() {
    this.requestId += 1
    const requestId = this.requestId
    this.setLoading(true)
    try {
      const {data} = await ApiUsersService.fetchAdminList({
        search: this.search || undefined,
        role: this.role,
        status: this.status,
        sort: this.sort,
        page: this.page,
        limit: this.limit,
      })
      if (requestId === this.requestId) this.setList(data)
    } catch (err) {
      console.log(err)
    }
    if (requestId === this.requestId) this.setLoading(false)
  }

  async create(userInfo) {
    try {
      const response = await ApiUsersService.createUser(userInfo)
      return response
    } catch (err) {
      this.setErrors(UsersModel.formErrors(err))
      return err.response
    }
  }

  async update(userId, userInfo) {
    try {
      const response = await ApiUsersService.updateUser(userId, userInfo)
      return response
    } catch (err) {
      this.setErrors(UsersModel.formErrors(err))
      return err.response
    }
  }

  async delete(userId) {
    const response = await ApiUsersService.deleteUser(userId)
    return response
  }

  // what the form shows: the fields' messages (422), or the one message of a refused action (roles, rights)
  static formErrors(err) {
    const errors = err?.response?.data?.errors
    if (!errors) return {message: 'Произошла ошибка'}
    if (errors.message) return {message: errors.message}
    return errors
  }

  // the server message for a failed action (ValidationError answers {errors: {field: text}})
  static errorText(err) {
    const errors = err?.response?.data?.errors
    if (!errors) return 'Произошла ошибка'
    if (errors.message) return errors.message
    return Object.values(errors).filter((v) => typeof v === 'string').join('. ') || 'Произошла ошибка'
  }

  async block(userId, reason) {
    await ApiUsersService.blockUser(userId, reason)
    await this.fetch()
  }

  async unblock(userId) {
    await ApiUsersService.unblockUser(userId)
    await this.fetch()
  }

  async setPassword(userId, password) {
    await ApiUsersService.setPassword(userId, password)
  }

  async setRoles(userId, roleIds) {
    await ApiUsersService.setRoles(userId, roleIds)
    await this.fetch()
  }
}

export const usersModel = new UsersModel()
export const usersErrorText = UsersModel.errorText
